import React from "react";
import "./Dpu_Mca_Certification.css";

const Dpu_Mca_Certification = () => {
  return (
    <>
      <section className="Dpu_Mca_Certification">
        <div className="certification">
          <div className="container">
            <div className="inner_div">
              <div className="row">
                <div className="col-lg-8 d-flex justify-content-center align-items-center certificate_col">
                  <h2 className="fs">
                    Industry Recognised
                    <br />
                    Online MCA Certification
                  </h2>
                </div>
                <div className="col-lg-4 text-center">
                  <img
                    className="img-fluid"
                    alt="Detailed degree certificate from DPU Dr D Y Patil Vidyapeeth Pune is displayed, showing the Master of Computer Application title, official seal, and signature, emphasizing accredited online MCA credentials."
                    src="/assets/images/dpu_mca/certification/mca-prog-certificate.webp"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="BeyondClass" id="BeyondClass">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <img
                src="/assets/images/dpu_mca/certification/beyondclass.webp"
                className="img-fluid"
                alt="Vertical infographic outlining the placement process with hexagon icons connected in a timeline format. The steps read Evaluation and Introduction with program briefing and skills analysis, Career Exploration and Resume Building, Placement Registration to track applications, Placement Guidance for interview preparation, and Placement Drive to connect with top recruiters for career advancement."
              />
            </div>
            <div className="col-lg-6 d-flex justify-content-center align-items-center">
              <div>
                <h2 className="text-black fs-4 beyond_title">
                  Career Support that Goes Beyond Classroom
                </h2>
                <p className="descn_text">
                  DPU-COL’s Employability Enhancement Program bridges the gap
                  between academics and industry needs through mock interviews,
                  resume building, mentorship, and industry collaboration. With
                  300+ hiring partners and 500+ job offers, the program equips
                  students with essential soft skills, tech know-how, and
                  practical exposure to ensure a smooth transition from
                  classroom to career.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dpu_Mca_Certification;
